export default "__VITE_ASSET__DkaYACgp__"